import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import classNames from 'classnames';
import { useIdleTimer } from 'react-idle-timer';

import HeaderPublic from 'components/header-public';
import HeaderAdmin from 'components/header-admin';
import Overlay from 'components/overlay';

import style from './style.module.css';

const { NODE_ENV } = process.env;

const getHeader = (header, admin) => {
  if (!header) return () => '';
  if (admin) return HeaderAdmin;
  return HeaderPublic;
};

const TIMEOUT_OVERLAY = 7000;

export const Page = ({
  header,
  sticky,
  overlay,
  children,
  className,
  admin,
  ...rest
}) => {
  const [showOverlay, setShowOverlay] = React.useState(false);
  useIdleTimer({
    timeout: TIMEOUT_OVERLAY,
    onIdle: () => {
      if (overlay) setShowOverlay(true);
    },
    onActive: () => setShowOverlay(false),
  });

  const title = 'NEWNEWNEW';
  const description =
    'NewNewNew is a creative agency focusing on CGI to create hyper-realistic realities';
  const url = 'https://newnewnew.studio';
  const image = `${url}/preview.png`;

  const Header = getHeader(header, admin);
  const customClassName = classNames(style.page, className);

  return (
    <div className={customClassName} {...rest}>
      {showOverlay ? <Overlay /> : null}
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />

        <meta property="og:title" content={title} />
        <meta property="og:image" content={image} />
        <meta property="og:site_name" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:description" content={description} />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@afk_mario" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:image" content={image} />
        <meta name="twitter:url" content={url} />
        <meta name="twitter:description" content={description} />

        <link rel="icon" href="/favicon.ico" />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#000" />
        <meta name="msapplication-TileColor" content="#000" />
        <meta name="theme-color" content="#000" />
      </Helmet>
      <Header sticky={sticky} />
      <main>{children}</main>
    </div>
  );
};

Page.propTypes = {
  sticky: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  header: PropTypes.bool,
  overlay: PropTypes.bool,
  css: PropTypes.shape({}),
  admin: PropTypes.bool,
};

Page.defaultProps = {
  sticky: true,
  className: null,
  header: true,
  children: null,
  css: null,
  overlay: NODE_ENV !== 'development',
  admin: false,
};

export default Page;
// export default ({ children }) => {
//   return <div>{children}</div>;
// };
